import axios, { AxiosError, AxiosInstance, InternalAxiosRequestConfig } from 'axios';

const CHAT_API_URL =
  process.env.REACT_APP_CHAT_API_URL ||
  // dev fallback
  'http://localhost:8001/chat-api';

const api: AxiosInstance = axios.create({
  baseURL: CHAT_API_URL,
  timeout: 30000,
});

api.interceptors.request.use((config: InternalAxiosRequestConfig) => {
  try {
    const token = localStorage.getItem('accessToken');
    if (token && config.headers) {
      config.headers.Authorization = `Bearer ${token}`;
    }
  } catch {
    /* ignore storage errors */
  }
  return config;
});

api.interceptors.response.use(
  (resp) => resp,
  (error: AxiosError) => {
    if (error.response?.status === 401) {
      try {
        localStorage.removeItem('accessToken');
      } catch {
        /* ignore */
      }
      // Send the user back to /login. Hard redirect so React state is reset.
      if (typeof window !== 'undefined' && window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
export { CHAT_API_URL };
